import moment from "moment";
// Use Pick<T,Y> here to maintain strong typing without manually redefinding/copying the props
export type FlightEditProps = Pick<server.dto.Flight, "phase" | "artist" | "travellers" | "bookingCode" | "travelAgency" | "notes">;
export type FlightSegmentsEdit = Record<number, Segment>;
export interface FlightEditState {
  flight: FlightEditProps
  segments: FlightSegmentsEdit
  initialArtist?: server.dto.ArtistSmall
  initialDate?: Date
};

export interface SegmentErrors {
  noDepartureAirportError: boolean
  noArrivalAirportError: boolean
  noAirlineError: boolean
  noFlightCodeError: boolean
  noFlightNumberError: boolean
  departureTooEarly: boolean
}

export interface Segment extends SegmentErrors {
  props: CommercialFlightEditProps & PrivateFlightEditProps
  type: server.dto.FlightTypes
}

export interface CommercialFlightEditProps {
  arrival: moment.Moment
  departure: moment.Moment

  arrivalAirport: server.dto.AirportSmall
  departureAirport: server.dto.AirportSmall

  departureTerminal: string
  arrivalTerminal: string

  departureGate: string
  arrivalGate: string

  airline: server.dto.Airline

  flightCode: string
  flightNumber: string

  aircraft: string

  seats: string

  travelClass: server.dto.FlightTravelClass

  eticket: string

  frequentFlyer: server.dto.FrequentFlyerProgram
}

export interface PrivateFlightEditProps {
  arrival: moment.Moment
  departure: moment.Moment

  arrivalAirport: server.dto.AirportSmall
  departureAirport: server.dto.AirportSmall

  departureTerminal: string
  arrivalTerminal: string

  departureGate: string
  arrivalGate: string

  access: string
  confirmationNumber: string
  aircraft: string
  capacity: string
}

export const getDefaultSegment = (): CommercialFlightEditProps & PrivateFlightEditProps => ({
  departure: moment.utc(),
  arrival: moment.utc(),

  arrivalAirport: null,
  departureAirport: null,

  arrivalGate: "",
  departureGate: "",
  departureTerminal: "",
  arrivalTerminal: "",

  airline: null,

  flightCode: "",
  flightNumber: "",

  aircraft: "",

  seats: "",

  travelClass: serverReference.flightTravelClasses.find(t => t.value === "unknown"),
  frequentFlyer: null,
  eticket: "",
  capacity: "",
  confirmationNumber: "",
  access: ""
});
